// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { pagination, fields, expand, search, filters} = params

    const { sortBy, sortDesc, page, itemsPerPage } = pagination
      ? pagination
      : [null, null, null, null];

    const sort = [];
    if(sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }


    let body = {
      page: page,
      sort: sort.join(","),
      rowsPerPage: itemsPerPage,
      search: search,
      fields: fields,
      expand: expand,
      filter: filters
    };

    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order", body)
        .then(({ data }) => {
          context.commit("set_orders", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          if(response)
            context.commit("set_error", response.data.errors);
        });
    });
  },

  delete(context, orderId) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.delete("order/"+orderId)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },

  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  addProduct(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("order/" + params.orderId + "/add-product", params.model)
          .then(({ data }) => {
            context.commit("unset_loading");
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
    });
  },
  addCustomRow(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("order/" + params.orderId + "/add-custom-row", params.model)
          .then(({ data }) => {
            context.commit("unset_loading");
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
    });
  },
  addProducts(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post(
        "order/" + params.orderId + "/add-products",
        params.model
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  removeProduct(context, {row}) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete("order/" + row.orderId + "/remove-row/" + row.id)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  create(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("order", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },

  validate(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId + "/validate", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          console.log("response", response)
          context.commit("set_error", response.data.message);
        });
    });
  },
  reopen(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId + "/reopen", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  
  cancel(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId + "/cancel", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  sent(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId + "/sent", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  markAsSent(context, params) {
 
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("order/" + params.orderId + "/mark-as-sent", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  sendToStock(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(
        "order/" + params.orderId + "/send-to-stock",
        params.model
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  get(context, params) {
    context.commit("set_loading");
    const expand = params.expand ? params.expand : null;
    return new Promise(resolve => {
      NewApiService.get("order/" + params.id, {
        expand: expand
      })
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data.order);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  print(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order/" + params.id + "/print/"+params.type)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  printCommercial(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order/" + params.id + "/print/commercial")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  printRows(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order/" + params.id + "/print/packagelist")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  updateAddress(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("order/" + params.orderId + "/addresse", {addressId:params.model.id, type: params.type})
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("unset_loading");
          reject(response)
        });
    });
  },
  copyBillingAddress(context, orderId) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put("order/" + orderId + "/copy-billing-addresse")
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("unset_loading");
          reject(response)
        });
    });
  },
  addPayout(context, params) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("order/" + params.model.orderId + "/payout", params.model )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        }).catch(({ response }) => {
          reject(response);
        })
    });
  },
  events(context, params) {
    context.commit("set_loading");
    const { sortBy, descending, page, rowsPerPage } = params.pagination;

    return new Promise(resolve => {
      NewApiService.get("order/" + params.orderId + "/events", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage
      }).then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      });
    });
  },

  getPayouts(context, orderId) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order/" + orderId + "/payouts")
      .then(({ data }) => {
        context.commit("unset_loading");
        resolve(data);
      })
      .catch(({ response }) => {
        context.commit("set_error", response.data.errors);
      });
    });
  }
};
